import React from 'react';
import ReactDOM from 'react-dom';

const ShadowDomContainer = ({
	children,
	containerId
}: {
	children: React.ReactNode;
	containerId: string;
}) => {
	const shadowHost = React.useRef<HTMLDivElement>(null);
	const [shadowRoot, setShadowRoot] = React.useState<ShadowRoot | null>(null);

	React.useEffect(() => {
		if (shadowHost.current && !shadowRoot) {
			const shadow = shadowHost.current.attachShadow({ mode: 'open' });
			setShadowRoot(shadow);
		}
	}, [shadowRoot]);

	return (
		<div
			id={containerId}
			ref={shadowHost}
		>
			{shadowRoot && ReactDOM.createPortal(children, shadowRoot)}
		</div>
	);
};

export { ShadowDomContainer };
